import {
  CollectionActions,
  CollectionStateSlice,
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformSupportFeedback } from './support-feedback.transformers';
import { SupportFeedbackCollection } from './support-feedback.types';

const PAYLOAD_TYPE = 'supportFeedback';

export function supportFeedbackReducer(
  state: CollectionStateSlice<SupportFeedbackCollection> = {},
  action: CollectionActions<SupportFeedbackCollection>,
) {
  switch (action.type) {
    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === PAYLOAD_TYPE) {
        const { result, ref } = action.payload;

        return mergeWebsocketDocuments<SupportFeedbackCollection>(
          state,
          transformIntoDocuments([result], transformSupportFeedback),
          ref,
        );
      }

      return state;
    }

    default:
      return state;
  }
}
